module.exports = __webpack_public_path__ + "img/wap-xcx.6bbd37c8.png";